import { jsxs as h, jsx as o } from "react/jsx-runtime";
import j from "../container/Container.js";
import m from "../../components/heading/Heading.js";
import i from "classnames";
import u from "../section-shape/SectionShape.js";
import '../../assets/HeadingAndContent.css';const v = "_container_19w7q_9", x = "_content_19w7q_12", S = "_heading_19w7q_21", y = "_description_19w7q_39", n = {
  container: v,
  content: x,
  heading: S,
  description: y
}, z = ({
  as: _ = "section",
  children: p,
  classnames: t,
  color: r = "light",
  description: e,
  extraHeadingContent: c,
  serifTitle: f,
  shape: d,
  shapeClassName: g,
  shapeTheme: N,
  title: q,
  titleVariant: w = "d3",
  ...a
}) => /* @__PURE__ */ h(
  j,
  {
    as: _,
    color: r,
    ...a,
    classnames: { content: n.content, container: i(n.container, t == null ? void 0 : t.container) },
    children: [
      /* @__PURE__ */ h("header", { className: i(n.heading, t == null ? void 0 : t.header), children: [
        /* @__PURE__ */ o(m, { as: "h1", variant: w, serif: f, children: q }),
        !!e && /* @__PURE__ */ o("p", { className: n.description, children: e }),
        !!c && c
      ] }),
      /* @__PURE__ */ o("div", { className: i(n.content, t == null ? void 0 : t.content), children: p }),
      !!d && /* @__PURE__ */ o(u, { color: r, shape: d, shapeTheme: N, className: g })
    ]
  }
);
export {
  z as default
};
